'use client';

import { useEffect, useRef } from 'react';

import Script from 'next/script';

import { Locale } from '@core/Entities/Locale/Locale.entity';
import { Typography } from '@gds/Typography/Typography';

import { BUSINESS_UNIT_ID, CARO_TEMPLATE_ID, TRUSTPILOT_URL } from '../TrustpilotWidget.constants';
import { trustpilotMessages } from '../TrustpilotWidget.messages';

import styles from './TrustpilotWidgetSlider.module.css';

interface TrustpilotWidgetSliderProps {
  strings: Pick<Record<keyof typeof trustpilotMessages, string>, 'trustpilotWidgetCustomer'>;
  locale: Locale;
}

export const TrustpilotWidgetSlider = ({ strings, locale }: TrustpilotWidgetSliderProps) => {
  const ref = useRef(null);
  const language = 'en-GB';
  const languages = 'en';

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    if (window.Trustpilot && locale !== 'fr') {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      window.Trustpilot.loadFromElement(ref.current, true);
    }
  }, []);

  if (locale === 'fr') return null;

  return (
    <>
      <Script
        src="https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js"
        strategy="afterInteractive"
      />

      <div className={styles.tpSlider} data-test-id="trustpilot-widget-slider">
        <Typography variant="h2">{strings.trustpilotWidgetCustomer}</Typography>
        <div
          ref={ref}
          className="trustpilot-widget"
          data-locale={language}
          data-template-id={CARO_TEMPLATE_ID}
          data-businessunit-id={BUSINESS_UNIT_ID}
          data-style-width="100%"
          data-theme="light"
          data-stars="5"
          data-review-languages={languages}
        >
          <a href={TRUSTPILOT_URL} target="_blank" rel="noopener" aria-label="trust widget slider">
            Trustpilot
          </a>
        </div>
      </div>
    </>
  );
};
